import { PropsWithChildren, memo, useContext } from 'react';
import { Header } from './Header/header';
import { Steps } from './Steps/steps';
import Quotation from './Quotation/quotation';
import './layout.scss';
import { useLocation, useParams } from 'react-router-dom';
import ROUTES, { pathWithChannel } from 'libs/constants/routes';
import Summary from './Summary/summary';
import { AppContext } from 'domains/commons/contexts/global/global-provider';

type Props = PropsWithChildren & {
  editVehicle: boolean;
  className?: string;
};

const Layout = ({ children, editVehicle, className = '' }: Props) => {
  const location = useLocation();
  const { channel = undefined } = useParams();
  const { pathname } = location;
  const { store } = useContext(AppContext);
  const isMirrorPage = store.mirrorPage.active;

  const showQuotation =
    pathname === ROUTES.STEP2 ||
    pathname === ROUTES.STEP2_MIRROW ||
    pathname === ROUTES.STEP2_BEX ||
    pathWithChannel('cotizacion', channel) === pathname;
  const showSummary =
    pathname === ROUTES.STEP3 ||
    pathname === ROUTES.STEP3_MIRROW ||
    pathname === ROUTES.STEP3_BEX ||
    pathWithChannel('resumen', channel) === pathname;
  return (
    <div className={`layout ${className}`}>
      <div className="layout--container">
        <Header isMirrorPage={isMirrorPage} />
        <div className="layout--content">
          <Steps />
          <div className="children">{children}</div>
        </div>
      </div>
      {showQuotation && <Quotation editVehicle={editVehicle} />}
      {showSummary && <Summary editVehicle={editVehicle} />}
    </div>
  );
};

export default memo(Layout);
